import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { redeemCode, toggleModal } from 'store/ui/actions'
import Button from '../forms/Button'
import Input from '../forms/Input'
import CircleSpinner from '../misc/CircleSpinner'
import styles from './styles/RedeemCode.css'

const RedeemCode = () => {
  const dispatch = useDispatch()
  const [code, setCode] = useState('')
  const loading = useSelector(({ ui }) => ui.redeemCodeLoading)
  const error = useSelector(({ ui }) => ui.redeemCodeError)
  const success = useSelector(({ ui }) => ui.redeemCodeSuccess)
  const user = useSelector(({ ui }) => ui.user)

  const handleChange = (e) => {
    setCode(e.target.value)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!user) {
      dispatch(toggleModal('login'))
      return
    }
    dispatch(redeemCode(code?.trim()))
  }

  return (
    <div className={styles.redeemCodeContainer}>
      <form onSubmit={handleSubmit} className={styles.redeemCodeForm}>
        <Input
          type='text'
          id='code'
          name='code'
          value={code}
          onChange={handleChange}
          placeholder='Enter redemption code'
        />

        <Button
          type='submit'
          color='blue'
          bold
          disabled={loading}
          className={styles.redeemCodeButton}
        >
          {loading ? <CircleSpinner size={25} /> : 'Redeem Code'}
        </Button>
      </form>
      {error && (
        <div className={styles.redeemCodeError}>
          {error}
        </div>
      )}
      {success && (
        <div className={styles.redeemCodeSuccess}>
          You have now redeemed your code.
        </div>
      )}
    </div>
  )
}

export default RedeemCode
